// extracted by mini-css-extract-plugin
export default {"levelBadge":"UserLevelMini_levelBadge_UoEF6"};